import Media from "@/models/Media";


export default class MediaTransformer {
    transform(data) {
        return new Media(
            data.id,
            data.deviceManualCommandId,
            data.dateRequested,
            data.state,
            data.createdByName,
            data.createdBy,
            data.createdOn,
            data.modifiedOn,
            data.modifiedBy,
            data.vehicleRegistrationNumber,
            data.driverName,
            data.hardwareId,
            data.hasBeenViewed,
            data.organizationName,
            data.organizationId,
            data.fleetName,
            data.fleetId,
            data.eventId,
            data.miniatureUri,
            data.lastActionOn,
        )
    }
}
